// angular
import { Component, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from '../../core/core.service';
import { concatMap, from, tap } from 'rxjs';

// others
import { AppService } from '../../app.service';
import { MeDashboardService } from './me-dashboard.service';
import { AuthService } from '../../core/auth.service';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { MePackageService } from '../packages/me-package.service';
import { KlenicoMeService } from '../me.service';
import { ProfileService } from '../profile/profile.service';
import { MeNPSComponent } from '../banners/nps/nps.component';
import { BannersService } from '../banners/banners.service';

@Component({
    selector: 'me-dashboard',
    templateUrl: './me-dashboard.component.html',
    styleUrls: ['./me-dashboard.component.scss'],
    providers: [MeDashboardService, MePackageService, ProfileService, BannersService]
})

export class MeDashboardComponent implements OnInit {
    @ViewChild('tabs', {static: false}) tabs: TabsetComponent;
    @ViewChild('npsComponent', {static: false}) npsComponent: MeNPSComponent;

    CARDS = {
        overview: {
            name: 'Overview Card',
            slug: 'overview-card'
        },
        diagnosis: {
            name: 'Diagnosis Prediction Card',
            slug: 'diagnosis-prediction-card'
        },
        documents: {
            name: 'Documents Card',
            slug: 'documents'
        },
        diga: {
            name: 'Diga Article Card',
            slug: 'diga-card'
        },
        barmer: {
            name: 'Barmer Article Card',
            slug: 'article-card'
        }
    };
    tabSelected = 0;
    myResultCards = [];
    myDashboardCards = [];
    data: any;
    content: any;
    language = this.translate.currentLang;
    url = 'login';
    form: FormGroup;
    submitted: boolean;
    errorMessage = '';
    hidePassword = true;
    srStep = 0;
    patientStep = 0;
    packages = {};
    isSRPaid = 0;
    isCVPaid = 0;
    isAppointmentDiscount;
    meetingTime;
    meetingUrl;
    appointmentStatus;
    canCreateNewSR = false;
    questionnaireToken = '';
    documentCount = 0;
    @Input() slug: string = '';
    colData = {
        left: [],
        right: []
    };


    constructor(
        public appService: AppService,
        public fb: FormBuilder,
        public coreService: CoreService,
        public translate: TranslateService,
        public meDashboardService: MeDashboardService,
        public meService: KlenicoMeService,
        public mePackageService: MePackageService,
        public bannerService : BannersService,
        public authService: AuthService,
        public router: Router,
        public route: ActivatedRoute,
    ) {
    }

    ngOnInit() {
        this.appService.isLoading = true;
        this.coreService.className = 'me-landing-page';
        this.meService.isNonMedicalFooter = false;
        this.getContent();
        this.translate.onLangChange.subscribe(() => {
            this.getContent();
        });

        this.meService.getDashboard().subscribe(res => {
            this.srStep = res['sr_step'];
            this.questionnaireToken = res['questionnaire_token'];
            this.patientStep = res['patient_step'];
            this.packages = res['packages'];
            this.isSRPaid = res['is_sr_paid'];
            this.isCVPaid = res['is_cv_paid'];
            this.isAppointmentDiscount = res['is_appointment_discount'];
            this.meetingTime = res['meeting_time'];
            this.meetingUrl = res['meeting_url'];
            this.appointmentStatus = res['appointment_status'];
            this.canCreateNewSR = res['can_create_sr'];
            this.meService.nextCreateSr = res['next_create_sr'];

            this.checkShowBanner(res);

            let serviceData = {
                'srStep': res['sr_step'],
                'patientStep': res['patient_step'],
                'packagesList': res['packages'],
            };
            this.meService.setKlenicoMeData(serviceData);

            this.route.queryParams.subscribe(params => {
                if (params && params?.tab) {
                    this.getCardItems(+params.tab);
                    return this.selectTab(+params.tab);
                }
                return this.selectTab(0);
            });
        });
    }

    getContent() {
        this.meDashboardService.getSBDashboard(this.translate.currentLang).subscribe(res => {
            if (res['story'] && res['story']['content']) {
                this.content = res['story']['content'];
            }
        });
    }

    selectTab(tabId: number) {
        if (this.tabs && this.tabs.tabs.length > 0) {
            this.tabs.tabs[tabId].active = true;
            this.tabSelected = tabId;
            this.router.navigate(['./'], {queryParams: {tab: tabId}, relativeTo: this.route});
            this.coreService.className = 'me-landing-page';

            // Unhighlight document count
            if (this.documentCount > 0 && tabId === 1) {
                this.bannerService.updateNotificationProcessed({
                    processed: true,
                    type: this.meService.TRIGGER_NOTIFICATIONS.DocumentNotification,
                    showOnce : true,
                }).subscribe(res => {
                    this.documentCount = 0;
                })
            }
        }
    }

    getCardItems(tabId: number){
        let config = JSON.parse(this.appService.getMeClinicConfig());
        let cardData = tabId === 0 ? this.myDashboardCards : this.myResultCards;
        let steps = tabId === 0 ? config?.activeBanners : config?.dashboardCards;
        if(cardData && cardData.length){
            return;
        }
        let i = 0;
        if(!steps){
            return;
        }
        from(steps).pipe(
            tap(() => {
                this.appService.isLoading = true;
            }),
            concatMap(
                step => this.appService.getStoryBlokSlugByUuid(step)
            ),
        ).subscribe(response => {
                cardData.push(response['story']);
                if (i % 2 === 0) {
                    this.colData.left.push(response['story']);
                } else {
                    this.colData.right.push(response['story']);
                }
                i++;
            },
            () => {
            },
            () => {
                this.appService.isLoading = false;
                this.data = cardData;
                if(tabId === 0){
                    this.myDashboardCards = cardData;
                }
                else{
                    this.myResultCards = cardData;
                }
                setTimeout(() => {
                    let hiddenTab = document.querySelectorAll("tabset > ul");
                    if (hiddenTab.length > 0) {
                        hiddenTab[0].remove();
                    }
                }, 1000);
            });
    }

    checkShowBanner(res) {
        this.meService.notifications = res['notifications'];
        this.meService.notifications.forEach(notification => {
            if (
                notification.type === this.meService.TRIGGER_NOTIFICATIONS.Login ||
                notification.type === this.meService.TRIGGER_NOTIFICATIONS.NoShow ||
                notification.type === this.meService.TRIGGER_NOTIFICATIONS.Document
            ) {
                this.meService.TRIGGERS[notification.type] = 1;
            }

            if (notification.type === this.meService.TRIGGER_NOTIFICATIONS.EvaluationDone && 
                !(this.patientStep === this.meService.PATIENTSTEPS.EXPORT_RECOMMENTDATION && this.canCreateNewSR)
            ) {
                // Refactor me to check delay
                this.meService.TRIGGERS.EvaluationDone = 1;
            }

            if (notification.type === this.meService.TRIGGER_NOTIFICATIONS.DynamicReportCreated) {
                setTimeout(() => {
                    this.npsComponent.checkShowNPSModal(notification, res['nps']);
                }, 500);
            }

            if (notification.type === this.meService.TRIGGER_NOTIFICATIONS.DocumentNotification) {
                this.documentCount++;

            }
        });
    }
}
